export enum WizardItemSubType {
	HEADER = 'header',
	HEADER_2 = 'header2',
	SECONDARY = 'secondary',
	BIRTH_DATE = 'birthdate',
	BIRTH_NUMBER = 'birthNumber',
	DATA = 'data',
	DOCUMENTATION_FILE = 'documentation_file',
	EMAIL = 'email',
	FORM = 'form',
	HTML = 'html',
	LABEL = 'label',
	LARGE = 'large',
	MEDIUM = 'medium',
	META = 'meta',
	NORMAL = 'normal',
	NUMBER = 'number',
	NUMBER_FIELD = 'numberfield',
	PARAGRAPH = 'paragraph',
	PASSWORD = 'password',
	PHONE_NUMBER = 'phoneNumber',
	PRIMARY = 'primary',
	PROFILE_PICTURE = 'profilePicture',
	RESPONSIVE = 'responsive',
	SUBTITLE = 'subtitle',
	TEXT = 'text',
	VIEW = 'condition',
	V_STACK = 'vstack',
	H_STACK = 'hstack',
	WARNING = 'warning',
}
